
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcDonutChart as ObcDonutChartElement} from '@oicl/openbridge-webcomponents/dist/bars-graphs/donut-chart/donut-chart.js';
 
 
 

 
 export const ObcDonutChart = createComponent({
   react: React,
   tagName: 'obc-donut-chart',
   elementClass: ObcDonutChartElement,
   events: {
     
   }
  });
 
 